module.exports = __webpack_public_path__ + "img/ring_of_protection.46d246a1.png";